export default {"src":"/_next/static/media/confetti_cone.e86af445.svg","height":89,"width":83,"blurWidth":0,"blurHeight":0};